export default {
	en: {
		edit: "Edit",
		delete: "Delete",
		cancel: "Cancel",
		save: "Save",
		confirm: "Confirm",
		add_item: "Add new item",
		confirm_delete: "This will permanently delete it. Continue?",
		warning_title: "Warning",
		all: "All",
		filter: "Filter",
		reset: "Reset",
		operations: "Operations",
		passwords_dont_match: "Passwords do not match",
		password_too_short: "Passwords to short",
		password_too_week: "Password to week",
		used: "used",
		new: "new",
		accepted: "accepted",
		pending: "pending",
		rejected: "rejected",

		login: {
			title: "Login",
			subtitle: "Login to flea-market",
			email_address: "Email address",
			enter_email: "Enter email",
			never_share: "We'll never share your email with anyone else",
			password: "Password",
			login_button: "Login now"
		},
		feedback: {
			page_title: "Feedback",
			message_placeholder: "Your feedback",
			message: "Feedback message",
			star_rating: "Star rating",
			send_feedback: "Send feedback"
		},
		menu: {
			last_stock_update: "Stocks last update",
			log_out: "Log out...",
			requests: "Requests",
			dashboard: "Dashboard",
			request_new_product: "Request new product",
			request_new_category: "Request new category",
			my_stocks: "My stocks",
			my_orders: "My orders",
			administration: "Administration",
			users: "Users",
			factories: "Factories",
			right_groups: "Right groups",
			product_categories: "Product Categories",
			products: "Products",
			reports: "Reports",
			unordered_products: "Unordered products",
			orders: "Orders",
			lazy_users: "Lazy users",
			settings: "Global settings",
			change_password: "Change Password",
			imports: "Imports",
			lang: "Lang",
			my_profile: "My profile"
		},
		users: {
			page_title: "Users",
			name: "Name",
			email: "Email",
			factory_country: "Plant Country",
			factory_code: "Plant Code",
			dialog_title: "User data",
			password: "Password",
			repeat_password: "Repeat password",
			user_group: "User Group",
			user_factory: "User Factory",
			change_password: "Change password",
			wrong_password: "Wrong pasword",
			good_password: "Good password",
			password_change_success: "Password changed with success",
			password_dialog_title: "Change password"
		},
		factories: {
			page_title: "Factories",
			email: "Email",
			notify_for_invoice_approval: "Notify for invoice on approval",
			address: "Address",
			name: "Name",
			country: "Country",
			code: "Factory Code",
			dialog_title: "Factory data"
		},
		right_groups: {
			page_title: "Right groups",
			dialog_title: "Right group data",
			name: "Name",
			group_rights: "Group rights",
			all_rights: "All rights",
			selected_rights: "Selected"
		},
		categories: {
			page_title: "Product categories",
			name: "Name",
			old_product_price: "Price for used item",
			proposed_by_user: "Proposed by user",
			dialog_title: "Category data",
			approve: "Approve",
			operations: "Operations",
			confirm_approve: "Approve this proposed category. Continue?"
		},
		products: {
			page_title: "Products",
			name: "Name",
			old_product_price: "Price for used item",
			proposed_by_user: "Proposed by user",
			dialog_title: "Product data",
			category: "Category",
			description: "Description",
			image: "Image",
			article_number: "Article number",
			approve: "Approve",
			confirm_approve: "Approve this proposed product. Continue?",
			required_name: "Name is required",
			required_article_number: "Article number is required",
			required_description: "Description is required",
			required_category: "Category is required",
			required_old_product_price: "Price for used item is required"
		},
		mystocks: {
			page_title: "My stocks",
			last_modified_date: "Last modification date",
			first_upload_date: "First upload date",
			new_products: "New Products",
			old_products: "Used Products",
			product: "Product",
			code: "Code",
			filters: "Filters",
			filter: "Filter",
			reset: "Reset",
			description: "Description",
			stock: "Stock",
			stocks_updated_with_success: "Stocks updated with success!",
			used_in_stock: "Used (qty.)",
			new_in_stock: "New (qty.)",
			price: "Price",
			only_available_for_new_products: "Only available for new products",
			new_products_in_stock: "New products in stock ( not used ones )",
			used_products_in_stock: "Used products in stock ( not new ones )",
			import_from_csv: "Import from CSV file:",
			choose_csv_file: "Choose CSV file",
			upload_csv_file: "Upload to server",
			example_csv_file: "Example CSV file",
			please_check: "Please check ",
			columns_used_in_csv: "Columns: Article number, Used quantity"
		},
		dashboard: {
			page_title: "Dashboard",
			unique_id: "Id",
			factory_code: "Factory code",
			seller_name: "Seller name",
			article_info: "Article info",
			product_status: "Status",
			quantity: "Quantity",
			price: "Price",
			order: "Order now",
			operations: "Operations",
			article_code: "Article Code:",
			quantity_range: "Quantity range:",
			category: "Category",
			used: "Used",
			new: "New",
			status: "Status"
		},
		buy_dialog: {
			dialog_title: "New Order",
			quantity: "Quantity",
			price: "Price",
			request_value: "Request Value",
			confirm_order: "Confirm Order"
		},
		settings: {
			page_title: "Global Settings",
			saved_success: "Saved succesfully!",
			smtp_host: "SMTP Host",
			smtp_port: "SMTP Port",
			smtp_user: "SMTP User",
			smtp_pass: "SMTP Pass",
			system_email: "System Email",
			system_name: "System Name",
			system_delivery_notice_number: "Starting delivery notice number",
			invoice_email: "Invoice department email",
			newsletter_subject:
				"Newsletter mail subject ( use [month] for month name )",
			newsletter_body: "Newsletter body",
			request_accepted_subject: "Request accepted mail subject",
			request_accepted_body:
				"Request accepted mail body ( use [link] for my orders page link )",
			request_rejected_subject: "Request rejected mail subject",
			request_rejected_body:
				"Request rejected mail body ( use [link] for my orders page link and [reason] for reason explanation )",
			new_request_subject: "New request mail subject",
			new_request_body: "New request mail body",

			request_feedback_subject: "Request feedback mail subject",
			request_feedback_message: "Request feedback mail message",

			bad_feedback_subject: "Bad feedback mail subject",
			bad_feedback_message: "Bad feedback mail body",

			notify_powerusers_to_update_stocks_subject:
				"Notify powerusers to update stocks subject",
			notify_powerusers_to_update_stocks_message:
				"Notify powerusers to update stocks message",

			monthly_notify_invoice_department_subject:
				"Monthly notify invoice department with last month orders subject"
		},
		myorders: {
			page_title: "My orders",
			unique_id: "Id",
			filter_status: "Status",
			factory_code: "Factory code",
			seller_name: "Seller name",
			buyer_name: "Buyer name",
			buyer_factory_code: "Buyer Factory",
			article_info: "Article info",
			product_status: "Status",
			request_date: "Request Date",
			quantity: "Quantity",
			price: "Price",
			order: "Order now",
			operations: "Operations",
			approve: "Approve",
			reject: "Reject",
			are_you_sure_you_approve: "Are you sure to approve this order?",
			attention_you_need_to_attach_invoice_to_delivery:
				"Attention! You have to attach the invoice to the delivery note!",
			rejection_reason: "Rejection reason",
			wrong_validate_reason: "Wrong validation reason!",
			no_action: "No action.",
			download_delivery_note: "Delivery Note",
			reason: "Reason"
		},
		report_unordered_products:{
			page_title: "Unordered products",
			factory_code: "Factory",
			article_number: "Article Number",
			product_name: "Article",
			first_upload_date: "First upload date",
			current_quantity: "Current Quantity",
			ordered_quantity: "Ordered Quantity",
			export_to_excel: "Export to excel",
		},
		report_order: {
			page_title: "Orders report",
			unique_id: "Id",
			dates: "Dates",
			factory_code: "Factory code",
			seller_name: "Seller name",
			article_info: "Article info",
			product_status: "Status",
			quantity: "Quantity",
			request_date: "Request Date",
			buyer_name: "Buyer",
			buyer_factory_code: "Buyer Factory Code",
			price: "Price",
			order: "Order now",
			operations: "Operations",
			approve: "Approve",
			reject: "Reject",
			are_you_sure_you_approve: "Are you sure to approve this order?",
			rejection_reason: "Rejection reason",
			wrong_validate_reason: "Wrong validation reason!",
			no_action: "No action.",
			download_delivery_note: "Delivery Note",
			filters: "Filters",
			reset: "Reset",
			article_code: "Article Code:",
			category: "Category",
			all: "All",
			accepted: "Accepted",
			approved: "Approved",
			rejected: "Rejected",
			pending: "Pending",
			buyer: "Buyer",
			seller: "Seller",
			excel: "Excel",
			reason: "Grund"
		},
		report_last_stock_update: {
			page_title: "Last stock update",
			user: "User",
			factory: "Factory",
			last_update: "Last update",
			days: "Days",
			all_users_are_ok: "All users are ok",
			export_to_excel: "Export to excel",
			never: "Never"
		},
		report_lazy_users: {
			page_title: "Lazy users report",
			inactive_users: "Inactive users",
			user: "User",
			factory: "Factory",
			all_users_are_ok: "All users are ok",
			days_since_last_login: "Days since last login",
			days_since_request: "Days since request",
			buyer: "Buyer",
			buyer_factory: "Buyer factory",
			days: "Days",
			not_responding_users: "Not responding users",
			inactive_users_export_to_excel: "Export to excel inactive users",
			not_responding_users_export_to_excel:
				"Export to excel not responding users",
			last_update: "Last update",
			never: "Never"
		},
		imports: {
			page_title: "Imports",
			import_from_csv: "Import from CSV file:",
			drop_csv_file_1: "Drop file here or",
			drop_csv_file_2: "click to upload",
			file_limit: "csv files with a size less than 500kb"
		},
		form_errors: {
			email_required: 'The "Email" field is required',
			address_required: 'The "Address" field is required',
			country_required: 'The "Country" field is required',
			short_code_required: 'The "Short code" field is required'
		},
		rights: {
			manage_right_groups: "Manage right groups",
			manage_users: "Manage users",
			manage_factories: "Manage factories",
			manage_categories: "Manage Categories",
			manage_products: "Manage Products",
			global_settings: "Global Settings",
			access_reports: "Access Reports",
			admin_menu_visible: "Admin Menu Visible",
			reports_menu_visible: "Reports Menu Visible"
		}
	},
	de: {
		edit: "Bearbeiten",
		delete: "Löschen",
		cancel: "Abbrechen",
		save: "Speichern",
		confirm: "Bestätigen",
		add_item: "Hinzufügen",
		confirm_delete:
			"Durch Bestätigen wird Punkt dauerhaft gelöscht. Fortfahren?",
		warning_title: "Warnung",
		all: "Alles",
		filter: "Filter",
		reset: "Abbruch",
		operations: "Transaktion",
		passwords_dont_match: "Passwörter stimmen nicht überein",
		password_too_short: "Passwörter zu kurz",
		password_too_week: "Passwörter in der Woche",
		used: "gebraucht",
		new: "neu",
		accepted: "Erledigt",
		pending: "Offen",
		rejected: "Abgelehnt",

		login: {
			title: "Titel",
			subtitle: "Anmelden in flea-market",
			email_address: "Email-adresse",
			enter_email: "Bestätigen der Email-adresse",
			never_share: "Wir werden Ihre Email-adresse an niemanden weitergeben",
			password: "Passwort",
			login_button: "Anmelden"
		},
		feedback: {
			page_title: "Feedback",
			message_placeholder: "Your feedback",
			message: "Feedback message",
			star_rating: "Star rating",
			send_feedback: "Send feedback"
		},
		menu: {
			last_stock_update: "Lagerstandsaktualisierung",
			log_out: "Abmelden...",
			requests: "Anfragen",
			dashboard: "Dashboard",
			request_new_product: "Neue Produkte anlegen",
			request_new_category: "Neue Kategorie anlegen",
			my_stocks: "Mein Lagerstand",
			my_orders: "Meine Bestellungen",
			administration: "Administration",
			users: "Benutzer",
			factories: "Betrieb",
			right_groups: "Berechtigungsgruppe",
			product_categories: "Produktkategorien",
			products: "Produkte",
			reports: "Auswertungen",
			orders: "Bestellungen",
			lazy_users: "Inaktive Benutzer",
			settings: "Allgemeine Einstellungen",
			change_password: "Passwort ändern",
			unordered_products: "Nicht bestellte Artikel",
			imports: "Importe",
			lang: "Sprache",
			my_profile: "Mein Profil"
		},
		users: {
			page_title: "Benutzer",
			name: "Name",
			email: "Email",
			factory_country: "Land des Betriebes",
			factory_code: "Betriebskürzel",
			dialog_title: "Benutzerdaten",
			password: "Passwort",
			repeat_password: "Passwort wiederholen",
			user_group: "Benutzergruppe",
			user_factory: "Betrieb des Benutzers",
			change_password: "Passwort ändern",
			wrong_password: "Falsches Passwort",
			good_password: "Gutes Passwort",
			password_change_success: "Passwort wurde erfolgreich geändert",
			password_dialog_title: "Passwort ändern"
		},
		factories: {
			page_title: "Betrieb",
			email: "Email",
			address: "Adresse",
			notify_for_invoice_approval: "Bei Genehmigung zur Rechnung benachrichtigen",
			name: "Name",
			country: "Land",
			code: "Betriebsabkürzung",
			dialog_title: "Betriebsdaten"
		},
		right_groups: {
			page_title: "Berechtigungsgruppe",
			dialog_title: "Berechtigungsgruppendaten",
			name: "Name",
			group_rights: "Berechtigungsgruppe",
			all_rights: "Alle Rechte",
			selected_rights: "ausgewählte Rechte",
			name_rquired: "Name ist erforderlich"
		},
		categories: {
			page_title: "Produktkategorien",
			name: "Name",
			old_product_price: "Preis für verwendeten Artikel",
			proposed_by_user: "Vorgeschlagen durch Benutzer",
			dialog_title: "Kategoriedaten",
			approve: "Genehmigen",
			operations: "Transaktion",
			confirm_approve: "Genehmigen Sie vorgeschlagene Kategorie. Fortfahren?"
		},
		products: {
			page_title: "Produkte",
			name: "Name",
			old_product_price: "Preis für verwendeten Artikel ",
			proposed_by_user: "Vorgeschlagen durch Benutzer",
			dialog_title: "Produktdaten",
			category: "Kategorie",
			description: "Beschreibung",
			image: "Das Foto",
			article_number: "Artikelnummer",
			approve: "Genehmigen",
			confirm_approve: "Genehmigen Sie vorgeschlagene Produkt, Fortfahren?",
			required_name: "Name ist erforderlich",
			required_article_number: "Artikelnummer ist erforderlich",
			required_description: "Beschreibung ist erforderlich",
			required_category: "Kategorie ist erforderlich",
			required_old_product_price:
				"Preis für gebrauchte Artikel ist erforderlich"
		},
		mystocks: {
			page_title: "Mein Lagerstand",
			last_modified_date: "Datum der letzten Änderung",
			first_upload_date: "Datum des ersten Uploads",
			new_products: "Neue Produkte",
			old_products: "Verwendete Produkte",
			filters: "Filters",
			filter: "Filter",
			stocks_updated_with_success: "Lagerstände sind erfolgreich aktualisiert!",
			product: "Produkt",
			reset: "Abbruch",
			code: "Code",
			description: "Beschreibung",
			stock: "Lagerstand",
			used_in_stock: "verwendete (Menge)",
			new_in_stock: "Neue (Menge)",
			price: "Preis",
			only_available_for_new_products: "Nur verfügbar für neue Produkte",
			new_products_in_stock: "Neue Produkte im Stand (noch nicht verwendet)",
			used_products_in_stock: "Verwendete Produkte im Stand( keine Neuen )",
			import_from_csv: "Importieren von CSV Datei:",
			choose_csv_file: "Wähle CSV Datei",
			upload_csv_file: "Hochladen auf Server",
			example_csv_file: "Beispiel CSV Datei",
			please_check: "Bitte prüfen ",
			columns_used_in_csv: "Spalte: Produktnummer, verwendete Menge"
		},
		dashboard: {
			page_title: "Dashboard",
			unique_id: "Id",
			factory_code: "Betriebskürzel",
			seller_name: "Verkäufername",
			article_info: "Artikelinformation",
			product_status: "Produktstatus",
			quantity: "Menge",
			price: "Preis",
			order: "Jetzt Bestellen",
			operations: "Transaktion",
			article_code: "Artikelnummer:",
			quantity_range: "Mengenumfang:",
			category: "Kategorie",
			used: "Gebraucht",
			new: "Neu",
			status: "Status"
		},
		buy_dialog: {
			dialog_title: "Neue Bestellung",
			quantity: "Menge",
			price: "Preis",
			request_value: "Angefragten Wert",
			confirm_order: "Bestellung bestätigen"
		},
		settings: {
			page_title: "Allgemeine Einstellungen",
			saved_success: "Speichern erfolgreich!",
			smtp_host: "SMTP Gast",
			smtp_port: "SMTP Port",
			smtp_user: "SMTP Benutzer",
			smtp_pass: "SMTP Zugang",
			system_email: "System Email",
			system_name: "System Name",
			system_delivery_notice_number: "Beginn der Lieferscheinnummer",
			invoice_email: "Email Rechnung",
			newsletter_subject:
				"Newsletter Mailüberschrift ( verwende [Monat] für Monatsname )",
			newsletter_body: "Newsletter Textkörper",
			request_accepted_subject: "Angefragte akzeptierte Mailüberschrift",
			request_accepted_body:
				"Angefragter akzeptierter Mailtextkörper ( Verwenden Sie [link] für meine Bestellungen )",
			request_rejected_subject: "Abgelehnte Anfrage Emailüberschrift",
			request_rejected_body:
				"Abgelehnte Anfrage Emailtextkörper ( Verwenden Sie [link] für meine Bestellungen und[reason]Beschreibung der Gründe )",
			new_request_subject: "Neue Anfrage Mailüberschrift",
			new_request_body: "Neue Anfrage Mailtextkörper",

			request_feedback_subject: "Feedback-Mail anfordern Mailüberschrift",
			request_feedback_message: "Feedback-Mail anfordern Mailtextkörper",

			bad_feedback_subject: "Ungültige Feedback-Mail Mailüberschrift",
			bad_feedback_message: "Ungültige Feedback-Mail Mailtextkörper",

			notify_powerusers_to_update_stocks_subject:
				"Benachrichtigen Sie den Power User um den aktuellen Bestand zu aktualisieren Mailüberschrift",
			notify_powerusers_to_update_stocks_message:
				"Benachrichtigen Sie den Power User um den aktuellen Bestand zu aktualisieren Mailtextkörper",

			monthly_notify_invoice_department_subject:
				"Bestellungen des letzten Monats für Fakturierung"
		},
		myorders: {
			page_title: "Meine Bestellungen",
			unique_id: "Id",
			filter_status: "Status",
			factory_code: "Betriebskürzel",
			seller_name: "Verkäufername",
			buyer_name: "Käufer",
			buyer_factory_code: "Käuferbetrieb",
			article_info: "Artikelinfo",
			product_status: "Status",
			quantity: "Menge",
			price: "Preis",
			request_date: "Anfragedatum",
			order: "Jetzt Bestellen",
			operations: "Transaktion",
			approve: "Genehmigen",
			reject: "Ablehnen",
			are_you_sure_you_approve:
				"Sind Sie sicher diese Bestellung zu genehmigen?",
			attention_you_need_to_attach_invoice_to_delivery:
				"Beachtung! Sie müssen die Rechnung dem Lieferschein beifügen!",
			rejection_reason: "Ablehnungsgrund",
			wrong_validate_reason: "Unzulässiger Grund!",
			no_action: "Keine Durchführung.",
			download_delivery_note: "Lieferschein",
			reason: "Grund"
		},
		report_unordered_products:{
			page_title: "Nicht bestellte Artikel",
			factory_code: "Betriebskürzel",
			article_number: "Artikel Info",
			product_name: "Artikel",
			first_upload_date: "Datum des ersten Uploads",
			current_quantity: "Aktuelle Menge",
			ordered_quantity: "Bestellte Menge",
			export_to_excel: "Excel exportieren",
		},

		report_order: {
			page_title: "Bestellauswertung",
			unique_id: "Id",
			dates: "Dates",
			factory_code: "Betriebskürzel",
			seller_name: "Verkäufername",
			article_info: "Artikel Info",
			request_date: "Anfragedatum",
			product_status: "Status",
			quantity: "Menge",
			price: "Preis",
			buyer_name: "Käufer",
			buyer_factory_code: "Käuferbetrieb",
			order: "Jetzt Bestellen",
			operations: "Transaktion",
			approve: "Genehmigen",
			reject: "Ablehnen",
			are_you_sure_you_approve:
				"Sind Sie sicher diese Bestellung zu genehmigen?",
			rejection_reason: "Ablehnungsgrund",
			wrong_validate_reason: "Unzulässiger Grund!",
			no_action: "Keine Aktion.",
			download_delivery_note: "Lieferschein",
			filters: "Filters",
			reset: "Abbruch",
			article_code: "Artikelnummer:",
			category: "Kategorie",
			all: "Alle",
			accepted: "Erledigt",
			approved: "Genehmigt",
			rejected: "Abgelehnt",
			pending: "Offen",
			buyer: "Käufer",
			seller: "Verkäufer",
			excel: "Excel",
			reason: "Grund"
		},
		report_last_stock_update: {
			page_title: "Letzte Lagerstandaktualisierung",
			user: "Benutzer",
			factory: "Betrieb",
			last_update: "Tage seit der letzten Aktualisierung",
			days: "Tage",
			all_users_are_ok: "Alle Benutzer sind in Ordnung",
			export_to_excel: "Excel exportieren",
			never: "Keine Aktualisierung"
		},
		report_lazy_users: {
			page_title: "Inaktive Benutzer Auswertung",
			inactive_users: "Inaktive Benutzer",
			user: "Benutzer",
			factory: "Betrieb",
			all_users_are_ok: "Alle Benutzer sind in Ordnung",
			days_since_last_login: "Tage seit letzter Anmeldung",
			days_since_request: "Tage seit letzter Anfrage",
			buyer: "Käufer",
			buyer_factory: "Betrieb des Käufers",
			days: "Tage",
			not_responding_users: "Keine Antwort von Benutzern",
			inactive_users_export_to_excel: "Inaktive Benutzer exportieren",
			not_responding_users_export_to_excel:
				"Benutzer die nicht reagieren, exportieren",
			last_update: "Tage seit der letzten Aktualisierung",
			never: "Keine Aktualisierung"
		},
		imports: {
			page_title: "Importe",
			import_from_csv: "Import aus CSV-Datei:",
			drop_csv_file_1: "Datei hier ablegen oder",
			drop_csv_file_2: "zum Hochladen klicken",
			file_limit: "CSV-Dateien mit einer Größe von weniger als 500 KB"
		},
		form_errors: {
			email_required: "Emailadresse ist erforderlich",
			address_required: "Adresse ist erforderlich",
			country_required: "Land ist erforderlich",
			short_code_required: "Betriebskürzel ist erforderlich"
		},
		rights: {
			manage_right_groups: "Verwalten Berechtigungsgruppen",
			manage_users: "Verwalten Benutzer",
			manage_factories: "Verwalten Betriebe",
			manage_categories: "Verwalten Produktkategorien",
			manage_products: "Verwalten Produkte",
			global_settings: "Allgemeine Einstellungen",
			access_reports: "Zugang Auswertungen",
			admin_menu_visible: "Administrationsmenü sichtbar",
			reports_menu_visible: "Auswertungsmenü sichtbar"
		}
	}
};
